import React from "react";
import { centered, flexer } from "../../styles/globalStyles";

const NotFound = () => {
  return (
    <div className={"notfound h-full" + centered}>
      <div className={flexer}>
        <h1 className="text-PRIMARY font-ExtraBold text-5xl">404</h1>
        <div className="spacer" />
        <div className="h-14 w-1 bg-black" />
        <div className="spacer" />
        <div>
          <h4 className="text-gray-500 font-Bold">Page Not Found</h4>
          <p>This page doesn't exist or was removed!</p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
